<template>
  <div id="group" >
    <h4>2018年"北汽集团"杯北京市中小学生校级冰球联赛</h4>
    <div>
      <h5>请选择赛事组别</h5>
      <van-search placeholder="请输入搜索关键词" />
      <h5>请选择参赛球队</h5>
      <van-search placeholder="请输入搜索关键词" />
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import { Search, Button } from 'vant'
Vue.use(Search).use(Button)
export default {
  name: 'SelectGroup',
  data() {
    return {}
  }
}
</script>
<style>
#group {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/select-group.vue